import type { ILanguageTranslations } from '@/composables/interfaces/i18nInterfaces'

const translations: ILanguageTranslations = {
  de: {
    accosbar: {
      location: 'Wohin reisen Sie?',
      date: 'Anreise - Abreise',
      occupancy: 'Gäste',
      search: 'Suchen'
    },
    enquirybar: {
      content: {
        singular: 'ausgewählte Unterkunft',
        plural: 'ausgewählte Unterkünfte'
      },
      generalLabelWithCount: 'Sammelanfrage an {count} Unterkünfte',
      singleLabel: 'Sammelanfrage an eine Unterkunft',
      tooManyAccos: 'Zu viele Unterkünfte - bitte Filter anpassen',
      noAccosLabel: 'Keine passenden Unterkünfte gefunden - Filter anpassen',
      enquiryButton: 'Jetzt anfragen'
    },
    enquirypagebar: {
      period: 'Zeitraum',
      persons: 'Personen'
    },
    dialog: {
      header: 'Reisedaten verwalten',
      travelDate: 'Ausgewählter Zeitraum',
      button: {
        apply: 'Anwenden',
        delete: 'Löschen'
      }
    },
    occupancy: {
      animals: 'Reise mit Tieren',
      animalsNotAllowed: 'Haustiere nicht erlaubt',
      weight: 'Gewicht',
      petsMessagePlaceholder: 'Anzahl, Größe, Rasse?',
      rooms: 'Zimmer/Appartement',
      adults: 'Erwachsene',
      children: 'Kinder',
      child: 'Kind',
      age: 'Alter',
      addRoom: '+ Zimmer/Apartment hinzufügen'
    },
    filter: {
      header: 'Filter',
      buttonLabel: 'Erweiterter Filter',
      actionButtonLabel: 'Filter anwenden',
      noResultActionButtonLabel: 'Filter anpassen',
      region: 'Regionen',
      location: 'Orte',
      locationPlaceholder: 'Ortschaft suchen',
      accomodation: 'Unterkunftstyp',
      accorating: 'Kategorie',
      reviewScore: 'Bewertung',
      themes: 'Themen',
      amenities: 'Ausstattungsmerkmale',
      boardings: 'Verpflegung',
      boardingAny: 'Beliebig',
      resultFound: 'Unterkünfte gefunden',
      map: {
        show: 'Karte',
        labelOpenAcco: 'Infos'
      },
      rating: {
        one: '1 Stern',
        two: '2 Sterne',
        three: '3 und 3S Sterne',
        four: '4 und 4S Sterne',
        five: '5 Sterne'
      },
      reviewScores: {
        good: 'Gut',
        veryGood: 'Sehr gut',
        wonderful: 'Ausgezeichnet'
      },
      appliedFilters: {
        removeAll: 'Alle entfernen',
        stars: 'Sterne'
      }
    },
    acco: {
      from: 'ab',
      perDay: 'pro Tag',
      visitLabel: 'Anfragen',
      ratings: {
        singular: 'Bewertung',
        plural: 'Bewertungen'
      },
      sustainabilityLogo: 'Nachhaltigkeitslogo',
      select: 'Merken',
      selected: 'Gemerkt',
      requestNow: 'Direkt anfragen',
      requestSuccess: 'Anfrage erfolgreich',
      requestFailed: 'Anfrage fehlgeschlagen'
    },
    enquiry: {
      nonBinding: 'Unverbindliche Anfrage',
      directAcco: 'Direkte Anfrage an:',
      generalAcco: {
        singular: 'Individuelles Angebot von folgender Unterkunft erhalten:',
        plural: 'Individuelle Angebote von folgenden Unterkünften erhalten:'
      },
      form: {
        checkInCheckOut: 'An- & Abreise',
        personalData: 'Persönliche Daten',
        email: 'E-Mail',
        salutation: 'Anrede',
        firstname: 'Vorname',
        surname: 'Nachname',
        phone: 'Telefon',
        comments: 'Bemerkungen & Fragen',
        anagraph: {
          stepInfo: {
            title: 'Geben Sie Ihre Daten ein, um personalisierte Angebote direkt von den Unterkünften zu erhalten!'
          },
          titles: {
            mr: 'Herr',
            mrs: 'Frau',
            family: 'Familie',
            org: 'Firma'
          },
          placeholders: {
            title: 'Titel auswählen',
            email: 'E-Mail-Adresse',
            firstName: 'Vorname',
            lastName: 'Nachname',
            phone: 'Telefonnummer',
            notes: 'Notizen'
          },
          errors: {
            general: { general: 'Ein Fehler ist aufgetreten, bitte versuchen sie es später erneut' },
            required: {
              title: 'Das Feld Titel ist erforderlich',
              email: 'Das Feld E-Mail ist erforderlich',
              firstName: 'Das Feld Vorname ist erforderlich',
              lastName: 'Das Feld Nachname ist erforderlich',
              phone: 'Das Feld Telefonnummer ist erforderlich',
              privacy: 'Sie müssen die Bedingungen und Konditionen akzeptieren',
              dateNotCorrect: 'Das gewählte Datum ist nicht korrekt',
              dateToShort: 'Sie müssen ein Ankunfts- und Abreisedatum wählen',
              message: 'Die Bemerkung darf nicht mehr als {0} zeichen lang sein',
              emptyCard: 'Keine Betriebe für die Anfrage ausgewählt'
            },
            valid: {
              email: 'Sie müssen eine gültige E-Mail-Adresse eingeben'
            }
          },
          labels: {
            privacy: 'Ja, ich stimme der {privacyReplaceText} zu.',
            privacyReplaceText: 'Verarbeitung meiner personenbezogenen Daten',
            newsletter: 'Ja, ich möchte den Newsletter von {portal} erhalten.',
            portal4: 'suedtirol.com',
            portal13: 'dolomites.com',
            portal102: 'suedtirol.com'
          },
          subLabels: {
            portal4: 'in Südtirol',
            portal13: 'in den Dolomiten',
            portal102: 'in Südtirol',
            newsletter:
              'Unser kostenloser Newsletter wird regelmäßig etwa einmal pro Monat versendet. Er enthält die besten Angebote für einen Urlaub {portal} sowie aktuelle Tipps aus der Redaktion. Eine Abmeldung ist jederzeit möglich.'
          }
        },
        rooms: {
          stepInfo: {
            title: 'Geben Sie Ihre Urlaubsdaten ein und erhalten Sie personalisierte Angebote per E-Mail direkt von den Unterkünften.'
          },
          errors: {
            required: {
              startDate: 'Das Feld Anreisedatum ist erforderlich',
              endDate: 'Das Feld Abreisedatum ist erforderlich',
              rooms: 'Sie müssen mindestens ein Zimmer/Appartement eingeben',
              petsMessage: 'Beschreibung von Tieren einfügen'
            },
            min: {
              rooms: 'Sie müssen mindestens ein Zimmer/Appartement eingeben'
            }
          }
        },
        services: {
          stepInfo: {
            title: 'Geben Sie Ihre Daten ein, um personalisierte Angebote direkt von den Unterkünften zu erhalten!'
          },
          placeholders: {
            accotypes: 'Wählen Sie den Unterkunftstyp',
            boardings: 'Wählen Sie die Verpflegung',
            amenities: 'Wählen Sie die Annehmlichkeiten',
            themes: 'Wählen Sie das Urlaubsthema',
            areas: 'Wählen Sie das Gebiet',
            searchAreas: 'Suche nach Regionen und Orten...'
          },
          errors: {
            required: {
              accotypes: 'Es muss mindestens ein Unterkunftstyp ausgewählt werden',
              boardings: 'Es muss mindestens eine Verpflegungsart ausgewählt werden',
              amenities: 'Es muss mindestens eine Ausstattung ausgewählt werden',
              themes: 'Es muss mindestens ein Urlaubsthema ausgewählt werden',
              areas: 'Es muss mindestens ein Reiseziel ausgewählt werden'
            },
            maxValue: {
              count: 'Es können maximal 80 Unterkünfte ausgewählt werden. Verwenden Sie weitere Filter.'
            }
          }
        },
        accoRecap: {
          dialogs: {
            removeAccoConfirm: {
              title: 'Unterkunft entfernen?',
              text: 'Bist du sicher, dass du die Unterkunft entfernen möchtest?',
              accetpLabel: 'Entfernen',
              cancelLabel: 'Abbrechen'
            }
          },
          stepInfo: {
            title: 'Hier sind die Unterkünfte, an die du deine Anfrage senden möchtest'
          }
        },
        nextLabelButton: 'Weiter',
        prevLabelButton: 'Zurück',
        submitLabelButton: 'Jetzt Anfrage senden'
      },
      recap: {
        accomodations: {
          singular: 'Unterkunft',
          plural: 'Unterkünfte'
        },
        adults: {
          singular: 'Erwachsener',
          plural: 'Erwachsene'
        },
        children: {
          singular: 'Kind',
          plural: 'Kinder'
        },
        rooms: {
          singular: 'Zimmer',
          plural: 'Zimmer'
        },
        accomodationTypes: 'Unterkunftstyp',
        locations: 'Region/Ort'
      },
      success: {
        direct: 'Unverbindliche direkte Anfrage',
        general: 'Unverbindliche Anfrage',
        status: 'Anfrage erfolgreich!',
        success: 'Ihre Anfrage wurde erfolgreich versendet.',
        similarAccos: 'Weitere Unterkünfte mit nur einem Klick anfragen'
      },
      selectedRoom: {
        type: 'Typ',
        size: 'Größe',
        occupancy: 'Belegung',
        person: 'Person',
        persons: 'Personen'
      },
      selectedPackage: {
        period: 'Zeitraum',
        nights: 'Nächte'
      }
    },
    accoTypes: {
      acco: 'Unterkunft',
      accos: 'Unterkünfte',
      hotel: 'Hotel',
      hotels: 'Hotels',
      fewo: 'Ferienwohnung / Residence',
      fewos: 'Ferienwohnungen / Residences'
    }
  },
  it: {
    accosbar: {
      location: 'Dove vuoi andare?',
      date: 'Arrivo - Partenza',
      occupancy: 'Ospiti',
      search: 'Ricerca'
    },
    enquirybar: {
      content: {
        singular: 'alloggio selezionato',
        plural: 'alloggi selezionati'
      },
      generalLabelWithCount: 'Richiesta cumulativa a {count} strutture',
      singleLabel: 'Richiesta cumulativa a una struttura',
      tooManyAccos: 'Troppe alloggi - perfeziona i filtri',
      noAccosLabel: 'Nessun alloggio trovato - modifica i filtri',
      enquiryButton: 'Richiedi ora'
    },
    enquirypagebar: {
      period: 'Periodo',
      persons: 'Persone'
    },
    dialog: {
      header: 'Gestire i dati di viaggio',
      travelDate: 'Periodo selezionato',
      button: {
        apply: 'Applicare',
        delete: 'Cancellare'
      }
    },
    occupancy: {
      animals: 'Viaggiare con gli animali',
      animalsNotAllowed: 'Animali domestici non ammessi',
      weight: 'peso',
      petsMessagePlaceholder: 'Quantità, dimensione, razza?',
      rooms: 'Camera/Appartamento',
      adults: 'Adulti',
      children: 'Bambini',
      child: 'Bambino',
      age: 'Età:',
      addRoom: '+ Aggiungi camera/appartamento'
    },
    filter: {
      header: 'Filtro',
      buttonLabel: 'Filtro esteso',
      actionButtonLabel: 'Applica il filtro',
      noResultActionButtonLabel: 'Personalizzare il filtro',
      region: 'Regioni',
      location: 'Località',
      locationPlaceholder: 'Cerca località',
      accomodation: 'Tipologia alloggi',
      accorating: 'Categoria',
      reviewScore: 'Punteggio degli ospiti',
      themes: 'Temi',
      amenities: 'Servizi',
      boardings: 'Trattamento',
      boardingAny: 'Qualsiasi',
      resultFound: 'Alloggi trovati',
      map: {
        show: 'Mappa',
        labelOpenAcco: 'Infos'
      },
      rating: {
        one: '1 stella',
        two: '2 stelle',
        three: '3 e 3S stelle',
        four: '4 e 4S stelle',
        five: '5 stelle'
      },
      reviewScores: {
        good: 'Buono',
        veryGood: 'Ottimo',
        wonderful: 'Eccellente'
      },
      appliedFilters: {
        removeAll: 'Rimuovi tutto',
        stars: 'stelle'
      }
    },
    acco: {
      from: 'da',
      perDay: 'al giorno',
      visitLabel: 'Richiedi',
      ratings: {
        singular: 'Recensione',
        plural: 'Recensioni'
      },
      sustainabilityLogo: 'Logo della sostenibilità',
      select: 'Memorizza',
      selected: 'Memorizzato',
      requestNow: 'Richiedi direttamente',
      requestSuccess: 'Richiesta riuscita',
      requestFailed: 'Richiesta fallita'
    },
    enquiry: {
      nonBinding: 'Richiesta non vincolante',
      directAcco: 'Richiesta diretta a:',
      generalAcco: {
        singular: "Ricevi un'offerta personalizzata dalla seguente struttura:",
        plural: 'Ricevi offerte personalizzate dalle seguenti strutture:'
      },
      form: {
        checkInCheckOut: 'Arrivo & Partenza',
        personalData: 'Dati personali',
        email: 'E-mail',
        salutation: 'Titolo',
        firstname: 'Nome',
        surname: 'Cognome',
        phone: 'Telefono',
        comments: 'Osservazioni e domande',
        anagraph: {
          stepInfo: {
            title: 'Inserisci i tuoi dati, per ricevere offerte personalizzate direttamente dalle strutture!'
          },
          titles: {
            mr: 'Signor',
            mrs: 'Signora',
            family: 'Famiglia',
            org: 'Ditta'
          },
          placeholders: {
            title: 'Select title',
            email: 'Email address',
            firstName: 'First name',
            lastName: 'Last name',
            phone: 'Phone number',
            notes: 'Notes'
          },
          errors: {
            general: { general: 'Si è verificato un errore, riprova più tardi' },
            required: {
              title: 'Il campo Titolo è obbligatorio',
              email: 'Il campo Email è obbligatorio',
              firstName: 'Il campo Nome è obbligatorio',
              lastName: 'Il campo Cognome è obbligatorio',
              phone: 'Il campo Telefono è obbligatorio',
              privacy: 'Devi accettare i termini e le condizioni',
              dateNotCorrect: 'La data inserita non è giusta',
              dateToShort: 'Devi selezionare una data di arrivo e di partenza',
              message: 'Il commento non deve essere più lungo di {0} caratteri.',
              emptyCard: 'Nessun alloggio selezionato per la richiesta'
            },
            valid: {
              email: 'Devi inserire un indirizzo email valido'
            }
          },
          labels: {
            privacy: 'Sì, acconsento al {privacyReplaceText}',
            privacyReplaceText: 'trattamento dei miei dati personali.',
            newsletter: 'Sì, desidero ricevere la newsletter di {portal}.',
            portal4: 'alto-adige.com',
            portal13: 'dolomites.com',
            portal102: 'alto-adige.com'
          },
          subLabels: {
            portal4: 'in Alto Adige',
            portal13: 'nelle Dolomiti',
            portal102: 'in Alto Adige',
            newsletter:
              'La nostra newsletter gratuita sarà inviata regolarmente una volta al mese, con le migliori offerte per vacanze {portal} e utili consigli della redazione. È possibile cancellarsi dal servizio in qualsiasi momento.'
          }
        },
        rooms: {
          stepInfo: {
            title: 'Inserisci i dati della tua vacanza e ricevi offerte personalizzate via e-mail, direttamente dalle strutture.'
          },
          errors: {
            required: {
              startDate: 'Il campo Data di Arrivo è obbligatorio',
              endDate: 'Il campo Data di Partenza è obbligatorio',
              rooms: 'Devi inserire almeno una camera/appartamento'
            },
            min: {
              rooms: 'Devi inserire almeno una camera/appartamento'
            }
          }
        },
        services: {
          stepInfo: {
            title: 'Inserisci i tuoi dati per ricevere offerte personalizzate direttamente dalle strutture!'
          },
          placeholders: {
            accotypes: 'Seleziona il tipo di alloggio',
            boardings: 'Seleziona il trattamento',
            amenities: 'Seleziona le attrezzature',
            themes: 'Seleziona il tema delle vacanze',
            areas: 'Seleziona la località',
            searchAreas: 'Cerca regioni e località...'
          },
          errors: {
            required: {
              accotypes: 'È necessario selezionare almeno un tipo di struttura',
              boardings: 'È necessario selezionare almeno un trattamento',
              amenities: "È necessario selezionare almeno un'attrezzatura",
              themes: 'È necessario selezionare almeno un tipo di vacanza',
              areas: 'È necessario selezionare almeno una località'
            },
            maxValue: {
              count: 'È possibile selezionare un massimo di 80 alloggi. Utilizzare altri filtri.'
            }
          }
        },
        accoRecap: {
          dialogs: {
            removeAccoConfirm: {
              title: "Rimuovere l'alloggio?",
              text: "Sei sicuro di voler eliminare l'alloggio?",
              accetpLabel: 'Rimuovi',
              cancelLabel: 'Annulla'
            }
          },
          stepInfo: {
            title: 'Ecco gli allogi a cui hai scelto di mandare la richiesta'
          }
        },
        nextLabelButton: 'Continua',
        prevLabelButton: 'Indietro',
        submitLabelButton: 'Invia la richiesta'
      },
      recap: {
        accomodations: {
          singular: 'alloggio',
          plural: 'alloggi'
        },
        adults: {
          singular: 'adulto',
          plural: 'adulti'
        },
        children: {
          singular: 'bambino',
          plural: 'bambini'
        },
        rooms: {
          singular: 'camera',
          plural: 'camere'
        },
        accomodationTypes: 'Tipo di alloggio',
        locations: 'Regione/località'
      },
      success: {
        direct: 'Richiesta diretta non vincolante',
        general: 'Richiesta non vincolante',
        status: 'Richiesta andata a buon fine!',
        success: 'La richiesta è stata inviata con successo.',
        similarAccos: 'Richiedi altri alloggi con un solo clic'
      },
      selectedRoom: {
        type: 'Tipo',
        size: 'Dimensione',
        occupancy: 'Occupazione',
        person: 'persona',
        persons: 'Persone'
      },
      selectedPackage: {
        period: 'Periodo',
        nights: 'Notti'
      }
    },
    accoTypes: {
      acco: 'Alloggio',
      accos: 'Alloggi',
      hotel: 'Hotel',
      hotels: 'Hotel',
      fewo: 'Appartamento / Residence',
      fewos: 'Appartamenti / Residence'
    }
  },
  en: {
    accosbar: {
      location: 'Where are you travelling to?',
      date: 'Arrival - Departure',
      occupancy: 'Guests',
      search: 'Search'
    },
    enquirybar: {
      content: {
        singular: 'alloggio selezionato',
        plural: 'alloggi selezionati'
      },
      generalLabelWithCount: 'Collective enquiry to {count} accommodations',
      singleLabel: 'Collective enquiry to one accommodation',
      tooManyAccos: 'Too many accomodations - please refine your filters',
      noAccosLabel: 'No matching accommodations found - adjust your filters',
      enquiryButton: 'Send enquiry'
    },
    enquirypagebar: {
      period: 'Period',
      persons: 'Persons'
    },
    dialog: {
      header: 'Manage travel data',
      travelDate: 'Selected period',
      button: {
        apply: 'Apply',
        delete: 'Delete'
      }
    },
    occupancy: {
      animals: 'Travelling with animals',
      animalsNotAllowed: 'Pets not allowed',
      weight: 'weight',
      petsMessagePlaceholder: 'Quantity, size, breed?',
      rooms: 'Room/Apartment',
      adults: 'Adults',
      children: 'Children',
      child: 'Child',
      age: 'Age:',
      addRoom: '+ Add room/apartment'
    },
    filter: {
      header: 'Filter',
      buttonLabel: 'Extended filter',
      actionButtonLabel: 'Apply filter',
      noResultActionButtonLabel: 'Customise filter',
      region: 'Regions',
      location: 'Localities',
      locationPlaceholder: 'Search locality',
      accomodation: 'Accommodation type',
      accorating: 'Category',
      reviewScore: 'Review score',
      themes: 'Themes',
      amenities: 'Amenity features',
      boardings: 'Meal type',
      boardingAny: 'Any',
      resultFound: 'Accommodations found',
      map: {
        show: 'Map',
        labelOpenAcco: 'Infos'
      },
      rating: {
        one: '1 star',
        two: '2 stars',
        three: '3 and 3S stars',
        four: '4 and 4S stars',
        five: '5 stars'
      },
      reviewScores: {
        good: 'Good',
        veryGood: 'Very Good',
        wonderful: 'Wonderful'
      },
      appliedFilters: {
        removeAll: 'Remove all',
        stars: 'Stars'
      }
    },
    acco: {
      from: 'from',
      perDay: 'per day',
      visitLabel: 'Request',
      ratings: {
        singular: 'Review',
        plural: 'Reviews'
      },
      sustainabilityLogo: 'Sustainability logo',
      select: 'Memorise',
      selected: 'Memorised',
      requestNow: 'Enquire directly',
      requestSuccess: 'Request successful',
      requestFailed: 'Request failed'
    },
    enquiry: {
      nonBinding: 'Non-binding enquiry',
      directAcco: 'Direct enquiry to:',
      generalAcco: {
        singular: 'Receive a personalised offer from the following accommodation:',
        plural: 'Receive personalised offers from the following accommodations:'
      },
      form: {
        checkInCheckOut: 'Check-in & Check-out',
        personalData: 'Personal data',
        email: 'E-mail',
        salutation: 'Salutation',
        firstname: 'First name',
        surname: 'Surname',
        phone: 'Telephone',
        comments: 'Remarks & questions',
        anagraph: {
          stepInfo: {
            title: 'Enter your details to receive personalized offers directly from the accommodations!'
          },
          titles: {
            mr: 'Mr.',
            mrs: 'Mrs.',
            family: 'Family',
            org: 'Company'
          },
          placeholders: {
            title: 'Select title',
            email: 'Email address',
            firstName: 'First name',
            lastName: 'Last name',
            phone: 'Phone number',
            notes: 'Notes'
          },
          errors: {
            general: { general: 'An error has occurred, please try again later' },
            required: {
              title: 'The Title field is required',
              email: 'The Email field is required',
              firstName: 'The First Name field is required',
              lastName: 'The Last Name field is required',
              phone: 'The Phone field is required',
              privacy: 'You must accept the terms and conditions',
              dateNotCorrect: 'The selected date is not correct',
              dateToShort: 'You must select an arrival and departure date',
              message: 'The comment must not be longer than {0} characters',
              emptyCard: 'No accommodations selected for the enquiry'
            },
            valid: {
              email: 'You must enter a valid email address'
            }
          },
          labels: {
            privacy: 'Yes, I agree to the {privacyReplaceText}</a>',
            privacyReplaceText: 'processing of my personal data.',
            newsletter: 'Yes, I would like to receive the newsletter by {portal}.',
            portal4: 'south-tirol.com',
            portal13: 'dolomites.com',
            portal102: 'south-tirol.com'
          },
          subLabels: {
            portal4: 'in South Tyrol',
            portal13: 'in the Dolomites',
            portal102: 'in South Tyrol',
            newsletter:
              'Our free newsletter is regularly sent once a month. It includes the best offers for a holiday {portal} as well as current tips by our editorial office. Unsubscribing is possible at any time.'
          }
        },
        rooms: {
          stepInfo: {
            title: 'Enter your holiday details and receive personalized offers via email directly from the accommodations.'
          },
          errors: {
            required: {
              startDate: 'The Arrival Date field is required',
              endDate: 'The Departure Date field is required',
              rooms: 'You must enter at least one room/apartment'
            },
            min: {
              rooms: 'You must enter at least one room/apartment'
            }
          }
        },
        services: {
          stepInfo: {
            title: 'Enter your details to receive personalized offers directly from the accommodations!'
          },
          placeholders: {
            accotypes: 'Select accommodation type',
            boardings: 'Select boarding',
            amenities: 'Select amenities',
            themes: 'Select vacation theme',
            areas: 'Select area',
            searchAreas: 'Search for regions and locations...'
          },
          errors: {
            required: {
              accotypes: 'You must select at least one type of accommodation',
              boardings: 'You must select at least one meal plan',
              amenities: 'You must select at least one facility',
              themes: 'You must select at least one type of holiday',
              areas: 'You must select at least one destination'
            },
            maxValue: {
              count: 'You can select a maximum of 80 accommodations. Please use additional filters.'
            }
          }
        },
        accoRecap: {
          dialogs: {
            removeAccoConfirm: {
              title: 'Remove accommodation?',
              text: 'Are you sure you want to remove the accommodation?',
              accetpLabel: 'Remove',
              cancelLabel: 'Cancel'
            }
          },
          stepInfo: {
            title: 'Here are the accommodations you have chosen to send your request to'
          }
        },
        nextLabelButton: 'Continue',
        prevLabelButton: 'Back',
        submitLabelButton: 'Send request now'
      },
      recap: {
        accomodations: {
          singular: 'accommodation',
          plural: 'accommodations'
        },
        adults: {
          singular: 'adult',
          plural: 'adults'
        },
        children: {
          singular: 'child',
          plural: 'children'
        },
        rooms: {
          singular: 'room',
          plural: 'rooms'
        },
        accomodationTypes: 'Accommodation type',
        locations: 'Region/location'
      },
      success: {
        direct: 'Non-binding direct enquiry',
        general: 'Non-binding enquiry',
        status: 'Enquiry successful!',
        success: 'Your enquiry has been sent successfully.',
        similarAccos: 'Request other accommodations with just one click'
      },
      selectedRoom: {
        type: 'Type',
        size: 'Size',
        occupancy: 'Occupancy',
        person: 'person',
        persons: 'persons'
      },
      selectedPackage: {
        period: 'Period',
        nights: 'Nights'
      }
    },
    accoTypes: {
      acco: 'Accommodation',
      accos: 'Accommodations',
      hotel: 'Hotel',
      hotels: 'Hotels',
      fewo: 'Apartment / Residence',
      fewos: 'Apartments / Residences'
    }
  },
  fr: {
    accosbar: {
      location: 'Où voyagez-vous?',
      date: 'Arrivée - Départ',
      occupancy: 'Invités',
      search: 'Rechercher'
    },
    enquirybar: {
      content: {
        singular: 'logement sélectionné pour la demande',
        plural: 'hébergements sélectionnés pour la demande'
      },
      generalLabelWithCount: 'Demande groupée à {count} hébergements',
      singleLabel: 'Demande groupée à un hébergement',
      tooManyAccos: 'Trop d’hébergements – affinez vos filtres',
      noAccosLabel: 'Aucun hébergement trouvé - modifiez les filtres',
      enquiryButton: 'Envoyer la demande'
    },
    enquirypagebar: {
      period: 'Période',
      persons: 'Personnes'
    },
    dialog: {
      header: 'Gérer les données de voyage',
      travelDate: 'Période sélectionnée',
      button: {
        apply: 'Appliquer',
        delete: 'Supprimer'
      }
    },
    occupancy: {
      animals: 'Voyage avec des animaux',
      animalsNotAllowed: 'Animaux non admis',
      weight: 'poids',
      petsMessagePlaceholder: 'Quantité, taille, race?',
      rooms: 'Chambre/Appartement',
      adults: 'Adultes',
      children: 'Enfants',
      child: 'Enfant',
      age: 'Âge:',
      addRoom: '+ Ajouter une chambre/un appartement'
    },
    filter: {
      header: 'Filtre',
      buttonLabel: 'Filtre avancé',
      actionButtonLabel: 'Appliquer un filtre',
      noResultActionButtonLabel: 'Adapter le filtre',
      region: 'Régions',
      location: 'Lieux',
      locationPlaceholder: 'Chercher une localité',
      accomodation: 'Type de logement',
      accorating: 'Catérogie',
      reviewScore: 'Note des commentaires',
      themes: 'Thèmes',
      amenities: "Caractéristiques de l'équipement",
      boardings: 'Restauration',
      boardingAny: 'Any',
      resultFound: 'Logements trouvés',
      map: {
        show: 'Carte',
        labelOpenAcco: 'Infos'
      },
      rating: {
        one: '1 étoile',
        two: '2 étoiles',
        three: '3 et 3S étoiles',
        four: '4 et 4S étoiles',
        five: '5 étoiles'
      },
      reviewScores: {
        good: 'Bien',
        veryGood: 'Très bien',
        wonderful: 'Fabuleux'
      },
      appliedFilters: {
        removeAll: 'Supprimer tout',
        stars: 'Étoiles'
      }
    },
    acco: {
      from: 'à partir de',
      perDay: 'par jour',
      visitLabel: 'Demande',
      ratings: {
        singular: 'Revue',
        plural: 'Revues'
      },
      sustainabilityLogo: 'Logo de la durabilité',
      select: 'Mémoriser',
      selected: 'Memorisé',
      requestNow: 'Demander directement',
      requestSuccess: 'Demande réussie',
      requestFailed: 'Échec de la demande'
    },

    enquiry: {
      nonBinding: 'Demande sans engagement',
      directAcco: 'Demande directe à:',
      generalAcco: {
        singular: "Recevez une offre personnalisée de l'établissement suivant:",
        plural: 'Recevez des offres personnalisées de la part des établissements suivants:'
      },
      form: {
        checkInCheckOut: 'Check-in et Check-out',
        personalData: 'Données personnelles',
        email: 'e-mail',
        salutation: 'titre de civilité',
        firstname: 'prénom',
        surname: 'nom de famille',
        phone: 'téléphone',
        comments: 'remarques & questions',
        anagraph: {
          stepInfo: {
            title: 'Entrez vos coordonnées pour recevoir des offres personnalisées directement des hébergements !'
          },
          titles: {
            mr: 'Monsieur',
            mrs: 'Madame',
            family: 'Famille',
            org: 'Entreprise'
          },
          placeholders: {
            title: 'Sélectionnez le titre',
            email: 'Adresse e-mail',
            firstName: 'Prénom',
            lastName: 'Nom de famille',
            phone: 'Numéro de téléphone',
            notes: 'Remarques'
          },
          errors: {
            general: { general: "Une erreur s'est produite, veuillez réessayer plus tard" },
            required: {
              title: 'Le champ Titre est obligatoire',
              email: 'Le champ E-mail est obligatoire',
              firstName: 'Le champ Prénom est obligatoire',
              lastName: 'Le champ Nom de famille est obligatoire',
              phone: 'Le champ Téléphone est obligatoire',
              privacy: 'Vous devez accepter les termes et conditions',
              dateNotCorrect: "La date sélectionnée n'est pas correcte",
              dateToShort: "Vous devez sélectionner une date d'arrivée et de départ",
              message: 'La remarque ne doit pas dépasser {0} caractères.',
              emptyCard: 'Aucun établissement sélectionné pour la demande'
            },
            valid: {
              email: 'Vous devez entrer une adresse e-mail valide'
            }
          },
          labels: {
            privacy: "Oui, j'accepte le {privacyReplaceText}",
            privacyReplaceText: 'traitement de mes données personnelles.',
            newsletter: 'Oui, je souhaite recevoir la newsletter de {portal}.',
            portal4: 'sud-tyrol.com',
            portal13: 'dolomites.com',
            portal102: 'sud-tyrol.com'
          },
          subLabels: {
            portal4: 'en Haut-Adige',
            portal13: 'dans les Dolomites',
            portal102: 'en Haut-Adige',
            newsletter:
              'Notre newsletter gratuite est envoyée régulièrement une fois par mois, avec les meilleures offres de vacances {portal} et des conseils utiles de la rédaction. Vous pouvez vous désabonner à tout moment.'
          }
        },
        rooms: {
          stepInfo: {
            title: 'Entrez vos informations de vacances et recevez des offres personnalisées par e-mail directement des hébergements.'
          },
          errors: {
            required: {
              startDate: "Le champ Date d'arrivée est obligatoire",
              endDate: 'Le champ Date de départ est obligatoire',
              rooms: 'Vous devez entrer au moins une chambre/appartement'
            },
            min: {
              rooms: 'Vous devez entrer au moins une chambre/appartement'
            }
          }
        },
        services: {
          stepInfo: {
            title: 'Entrez vos coordonnées pour recevoir des offres personnalisées directement des hébergements !'
          },
          placeholders: {
            accotypes: "Sélectionnez le type d'hébergement",
            boardings: 'Sélectionnez le type de pension',
            amenities: 'Sélectionnez les équipements',
            themes: 'Sélectionnez le thème des vacances',
            areas: 'Sélectionnez la localité',
            searchAreas: 'Rechercher des régions et des lieux...'
          },
          errors: {
            required: {
              accotypes: "Vous devez sélectionner au moins un type d'hébergement",
              boardings: 'Vous devez sélectionner au moins un type de pension',
              amenities: 'Vous devez sélectionner au moins un équipement',
              themes: 'Vous devez sélectionner au moins un type de vacances',
              areas: 'Vous devez sélectionner au moins une destination'
            },
            maxValue: {
              count: "Vous pouvez sélectionner un maximum de 80 hébergements. Utilisez d'autres filtres."
            }
          }
        },
        accoRecap: {
          dialogs: {
            removeAccoConfirm: {
              title: "Supprimer l'hébergement ?",
              text: "Êtes-vous sûr de vouloir supprimer l'hébergement ?",
              accetpLabel: 'Supprimer',
              cancelLabel: 'Annuler'
            }
          },
          stepInfo: {
            title: "Voici les hébergements auxquels vous avez choisi d'envoyer votre demande"
          }
        },
        nextLabelButton: 'Continuer',
        prevLabelButton: 'Retour',
        submitLabelButton: 'Envoyer la demande'
      },
      recap: {
        accomodations: {
          singular: 'hébergement',
          plural: 'hébergements'
        },
        adults: {
          singular: 'adulte',
          plural: 'adultes'
        },
        children: {
          singular: 'enfant',
          plural: 'enfants'
        },
        rooms: {
          singular: 'chambre',
          plural: 'chambres'
        },
        accomodationTypes: "Type d'hébergement",
        locations: 'Région/localité'
      },
      success: {
        direct: 'Demande directe sans engagement',
        general: 'Demande directe sans engagement',
        status: 'Demande réussie!',
        success: 'Votre demande a été envoyée avec succès.',
        similarAccos: "Demander d'autres hébergements en un seul clic"
      },
      selectedRoom: {
        type: 'Type',
        size: 'Taille',
        occupancy: 'Occupation',
        person: 'Personne',
        persons: 'Personnes'
      },
      selectedPackage: {
        period: 'période',
        nights: 'Nuits'
      }
    },
    accoTypes: {
      acco: 'Hébergement',
      accos: 'Hébergements',
      hotel: 'Hôtel',
      hotels: 'Hôtels',
      fewo: 'Appartement de vacances / Résidence',
      fewos: 'Appartements de vacances / Résidences'
    }
  },
  pl: {
    accosbar: {
      location: 'Dokąd podróżujesz?',
      date: 'Przylot - Odlot',
      occupancy: 'Goście',
      search: 'Wyszukiwanie'
    },
    enquirybar: {
      content: {
        singular: 'logement sélectionné pour la demande',
        plural: 'hébergements sélectionnés pour la demande'
      },
      generalLabelWithCount: 'Zapytanie zbiorcze do {count} obiektów',
      singleLabel: 'Zapytanie zbiorcze do obiektu noclegowego',
      tooManyAccos: 'Za dużo obiektów - doprecyzuj filtry',
      noAccosLabel: 'Brak pasujących obiektów - zmień filtry',
      enquiryButton: 'Wyślij zapytanie'
    },
    enquirypagebar: {
      period: 'Okres',
      persons: 'Osoby'
    },
    dialog: {
      header: 'Zarządzanie danymi podróży',
      travelDate: 'Wybrany okres',
      button: {
        apply: 'Zastosuj',
        delete: 'Usuń'
      }
    },
    occupancy: {
      animals: 'Podróżowanie ze zwierzętami',
      animalsNotAllowed: 'Zwierzęta nie są dozwolone',
      weight: 'waga',
      petsMessagePlaceholder: 'Ilość, rozmiar, rasa?',
      rooms: 'Pokój/Apartament',
      adults: 'Dorośli',
      children: 'Dzieci',
      child: 'Dziecko',
      age: 'Wiek:',
      addRoom: '+ Dodaj pokój/mieszkanie'
    },
    filter: {
      header: 'Filtr',
      buttonLabel: 'Filtr rozszerzony',
      actionButtonLabel: 'Zastosuj filtr',
      noResultActionButtonLabel: 'Dostosuj filtr',
      region: 'Regiony',
      location: 'Miejsca',
      locationPlaceholder: 'Wyszukaj miejscowość',
      accomodation: 'Typ zakwaterowania',
      accorating: 'Kategorii',
      reviewScore: 'Ocena Gości',
      themes: 'Tematy',
      amenities: 'Cechy wyposażenia',
      boardings: 'Catering',
      boardingAny: 'Any',
      resultFound: 'Accommodatie gevonden',
      map: {
        show: 'Mapie',
        labelOpenAcco: 'Infos'
      },
      rating: {
        one: '1 gwiazdka',
        two: '2 gwiazdki',
        three: '3 i 3S gwiazdki',
        four: '4 i 4S gwiazdki',
        five: '5 gwiazdki'
      },
      reviewScores: {
        good: 'Dobry',
        veryGood: 'Bardzo dobry',
        wonderful: 'Znakomity'
      },
      appliedFilters: {
        removeAll: 'Usuń wszystko',
        stars: 'Gwiazdy'
      }
    },
    acco: {
      from: 'z',
      perDay: 'dziennie',
      visitLabel: 'Żądanie',
      ratings: {
        singular: 'Recenzja',
        plural: 'Recenzje'
      },
      sustainabilityLogo: 'Logo zrównoważonego rozwoju',
      select: 'Zapamiętać',
      selected: 'Zapamiętane',
      requestNow: 'Zapytaj bezpośrednio',
      requestSuccess: 'Zapytanie zakończone sukcesem',
      requestFailed: 'Zapytanie nie powiodło się'
    },
    enquiry: {
      nonBinding: 'Niewiążące zapytanie',
      directAcco: 'Bezpośrednie zapytanie do:',
      generalAcco: {
        singular: 'Otrzymaj indywidualną ofertę od następującego obiektu:',
        plural: 'Otrzymaj indywidualne oferty od następujących obiektów:'
      },
      form: {
        checkInCheckOut: 'Zameldowanie i Wymeldowanie',
        personalData: 'Dane osobowe',
        email: 'Email',
        salutation: 'Salutation',
        firstname: 'Imię',
        surname: 'nazwisko',
        phone: 'Telefon',
        comments: 'Uwagi i pytania',
        anagraph: {
          stepInfo: {
            title: 'Wprowadź swoje dane, aby otrzymać spersonalizowane oferty bezpośrednio od obiektów!'
          },
          titles: {
            mr: 'Pan',
            mrs: 'Pani',
            family: 'Rodzina',
            org: 'Firma'
          },
          placeholders: {
            title: 'Wybierz tytuł',
            email: 'Adres e-mail',
            firstName: 'Imię',
            lastName: 'Nazwisko',
            phone: 'Numer telefonu',
            notes: 'Notatki'
          },
          errors: {
            general: { general: 'Wystąpił błąd, spróbuj ponownie później' },
            required: {
              title: 'Pole Tytuł jest wymagane',
              email: 'Pole E-mail jest wymagane',
              firstName: 'Pole Imię jest wymagane',
              lastName: 'Pole Nazwisko jest wymagane',
              phone: 'Pole Telefon jest wymagane',
              privacy: 'Musisz zaakceptować warunki i zasady',
              dateNotCorrect: 'Wybrana data jest niepoprawna',
              dateToShort: 'Musisz wybrać datę przyjazdu i wyjazdu',
              message: 'Komentarz nie może być dłuższy niż {0} znaków',
              emptyCard: 'Żadna firma nie została wybrana do zapytania'
            },
            valid: {
              email: 'Musisz podać prawidłowy adres e-mail'
            }
          },
          labels: {
            privacy: 'Tak, wyrażam zgodę na {privacyReplaceText}',
            privacyReplaceText: 'przetwarzanie moich danych osobowych.',
            newsletter: 'Tak, chcę otrzymywać newsletter od {portal}.',
            portal4: 'poludniowy-tyrol.com',
            portal13: 'dolomites.com',
            portal102: 'poludniowy-tyrol.com'
          },
          subLabels: {
            portal4: 'w Południowym Tyrolu',
            portal13: 'w Dolomitach',
            portal102: 'w Południowym Tyrolu',
            newsletter:
              'Nasz darmowy newsletter jest regularnie wysyłany raz w miesiącu i zawiera najlepsze oferty na wakacje {portal} oraz przydatne wskazówki od redakcji. Możesz się wypisać w dowolnym momencie.'
          }
        },
        rooms: {
          stepInfo: {
            title: 'Wprowadź dane swojego urlopu i otrzymuj spersonalizowane oferty na e-mail bezpośrednio od obiektów.'
          },
          errors: {
            required: {
              startDate: 'Pole Data Przyjazdu jest wymagane',
              endDate: 'Pole Data Wyjazdu jest wymagane',
              rooms: 'Musisz podać co najmniej jeden pokój/apartament'
            },
            min: {
              rooms: 'Musisz podać co najmniej jeden pokój/apartament'
            }
          }
        },
        services: {
          stepInfo: {
            title: 'Wprowadź swoje dane, aby otrzymać spersonalizowane oferty bezpośrednio od obiektów!'
          },
          placeholders: {
            accotypes: 'Wybierz typ zakwaterowania',
            boardings: 'Wybierz rodzaj wyżywienia',
            amenities: 'Wybierz udogodnienia',
            themes: 'Wybierz temat wakacji',
            areas: 'Wybierz lokalizację',
            searchAreas: 'Szukaj regionów i miejscowości...'
          },
          errors: {
            required: {
              accotypes: 'Musisz wybrać przynajmniej jeden typ zakwaterowania',
              boardings: 'Musisz wybrać przynajmniej jeden rodzaj wyżywienia',
              amenities: 'Musisz wybrać przynajmniej jedno udogodnienie',
              themes: 'Musisz wybrać przynajmniej jeden typ wakacji',
              areas: 'Musisz wybrać przynajmniej jedną lokalizację'
            },
            maxValue: {
              count: 'Możesz wybrać maksymalnie 80 zakwaterowań. Użyj innych filtrów.'
            }
          }
        },
        accoRecap: {
          dialogs: {
            removeAccoConfirm: {
              title: 'Usunąć zakwaterowanie?',
              text: 'Czy na pewno chcesz usunąć zakwaterowanie?',
              accetpLabel: 'Usuń',
              cancelLabel: 'Anuluj'
            }
          },
          stepInfo: {
            title: 'Oto miejsca noclegowe, do których zdecydowałeś się wysłać swoje zapytanie'
          }
        },
        nextLabelButton: 'Kontynuuj',
        prevLabelButton: 'Powrót',
        submitLabelButton: 'Wyślij zapytanie'
      },
      recap: {
        accomodations: {
          singular: 'zakwaterowanie',
          plural: 'zakwaterowania'
        },
        adults: {
          singular: 'dorosły',
          plural: 'dorośli'
        },
        children: {
          singular: 'dziecko',
          plural: 'dzieci'
        },
        rooms: {
          singular: 'pokój',
          plural: 'pokoje'
        },
        accomodationTypes: 'Typ zakwaterowania',
        locations: 'Region/lokalizacja'
      },
      success: {
        direct: 'Niewiążące zapytanie bezpośrednie',
        general: 'Niewiążące zapytanie',
        status: 'Zapytanie powiodło się!',
        success: 'Zapytanie zostało wysłane pomyślnie.',
        similarAccos: 'Zamów więcej zakwaterowania jednym kliknięciem'
      },
      selectedRoom: {
        type: 'Typ',
        size: 'Size',
        occupancy: 'Obłożenie',
        person: 'Osoba',
        persons: 'Osoby'
      },
      selectedPackage: {
        period: 'Period',
        nights: 'Nights'
      }
    },
    accoTypes: {
      acco: 'Nocleg',
      accos: 'Noclegi',
      hotel: 'Hotel',
      hotels: 'Hotele',
      fewo: 'Apartament wakacyjny / Rezydencja',
      fewos: 'Apartamenty wakacyjne / Rezydencje'
    }
  },
  nl: {
    accosbar: {
      location: 'Waar gaat u naartoe?',
      date: 'Aankomst - Vertrek',
      occupancy: 'Gasten',
      search: 'Zoeken'
    },
    enquirybar: {
      content: {
        singular: 'geselecteerde accommodatie',
        plural: 'geselecteerde accommodaties'
      },
      generalLabelWithCount: 'Groepsaanvraag naar {count} accommodaties',
      singleLabel: 'Collectieve aanvraag naar een accommodatie',
      tooManyAccos: 'Te veel accommodaties – pas je filters aan',
      noAccosLabel: 'Geen passende accommodaties gevonden - pas je filters aan',
      enquiryButton: 'Nu aanvragen'
    },
    enquirypagebar: {
      period: 'Tijdsperiode',
      persons: 'Personen'
    },
    dialog: {
      header: 'Reisgegevens beheren',
      travelDate: 'Geselecteerde periode',
      button: {
        apply: 'Toepassen',
        delete: 'Verwijderen'
      }
    },
    occupancy: {
      animals: 'Reizen met dieren',
      animalsNotAllowed: 'Huisdieren niet toegestaan',
      weight: 'weight',
      petsMessagePlaceholder: 'Aantal, grootte, ras?',
      rooms: 'Kamer/Appartement',
      adults: 'Dorośli',
      children: 'Kinderen',
      child: 'Kind',
      age: 'Leeftijd:',
      addRoom: '+ Kamer/appartement toevoegen'
    },
    filter: {
      header: 'Filter',
      buttonLabel: 'Uitgebreid filter',
      actionButtonLabel: 'Filter toepassen',
      noResultActionButtonLabel: 'Filter aanpassen',
      region: "Regio's",
      location: 'Plaatsen',
      locationPlaceholder: 'Plaats zoeken',
      accomodation: 'Type accommodatie',
      accorating: 'Categorie',
      reviewScore: 'Beoordelingen',
      themes: "Thema's",
      amenities: 'Uitrusting',
      boardings: 'Catering',
      boardingAny: 'Any',
      resultFound: 'Accommodatie gevonden',
      map: {
        show: 'Kaart',
        labelOpenAcco: 'Infos'
      },
      rating: {
        one: '1 ster',
        two: '2 sterren',
        three: '3 und 3S Sterne',
        four: '4 en 4S sterren',
        five: '5 sterren'
      },
      reviewScores: {
        good: 'Goed',
        veryGood: 'Zeer goed',
        wonderful: 'Prachtig'
      },
      appliedFilters: {
        removeAll: 'Alles verwijderen',
        stars: 'Sterren'
      }
    },
    acco: {
      from: 'van',
      perDay: 'per dag',
      visitLabel: 'Verzoek',
      ratings: {
        singular: 'Beoordeling',
        plural: 'Beoordelingen'
      },
      sustainabilityLogo: 'Duurzaamheidslogo',
      select: 'Memoriseren',
      selected: 'Gememoriseerd',
      requestNow: 'Direct aanvragen',
      requestSuccess: 'Verzoek succesvol',
      requestFailed: 'Verzoek mislukt'
    },
    enquiry: {
      nonBinding: 'Niet-bindende vraag',
      directAcco: 'Directe aanvraag aan:',
      generalAcco: {
        singular: 'Ontvang een persoonlijke aanbieding van de volgende accommodatie:',
        plural: 'Ontvang persoonlijke aanbiedingen van de volgende accommodaties:'
      },
      form: {
        checkInCheckOut: 'Inchecken en Uitchecken',
        personalData: 'Persoonlijke gegevens',
        email: 'E-mail',
        salutation: 'aanhef',
        firstname: 'Voornaam',
        surname: 'Achternaam',
        phone: 'Telefoon',
        comments: 'Opmerkingen & vragen',
        anagraph: {
          stepInfo: {
            title: 'Voer je gegevens in om gepersonaliseerde aanbiedingen rechtstreeks van de accommodaties te ontvangen!'
          },
          titles: {
            mr: 'De heer',
            mrs: 'Mevrouw',
            family: 'Familie',
            org: 'Bedrijf'
          },
          placeholders: {
            title: 'Selecteer titel',
            email: 'E-mailadres',
            firstName: 'Voornaam',
            lastName: 'Achternaam',
            phone: 'Telefoonnummer',
            notes: 'Notities'
          },
          errors: {
            general: { general: 'Er is een fout opgetreden, probeer het later opnieuw' },
            required: {
              title: 'Het veld Titel is verplicht',
              email: 'Het veld E-mail is verplicht',
              firstName: 'Het veld Voornaam is verplicht',
              lastName: 'Het veld Achternaam is verplicht',
              phone: 'Het veld Telefoon is verplicht',
              privacy: 'U moet de voorwaarden accepteren',
              dateNotCorrect: 'De geselecteerde datum is niet correct',
              dateToShort: 'U moet een aankomst- en vertrekdatum selecteren',
              message: 'De opmerking mag niet langer zijn dan {0} tekens',
              emptyCard: 'Geen bedrijven geselecteerd voor het onderzoek'
            },
            valid: {
              email: 'U moet een geldig e-mailadres invoeren'
            }
          },
          labels: {
            privacy: 'Ja, ik geef toestemming voor het {privacyReplaceText}',
            privacyReplaceText: 'verwerken van mijn persoonsgegevens.',
            newsletter: 'Ja, ik wil de nieuwsbrief van {portal} ontvangen.',
            portal4: 'zuid-tirol-italie.nl',
            portal13: 'dolomites.com',
            portal102: 'zuid-tirol-italie.nl'
          },
          subLabels: {
            portal4: 'in Zuid-Tirol',
            portal13: 'in de Dolomieten',
            portal102: 'in Zuid-Tirol',
            newsletter:
              'Onze gratis nieuwsbrief wordt regelmatig eens per maand verzonden, met de beste aanbiedingen voor vakanties {portal} en handige tips van de redactie. U kunt zich op elk moment afmelden.'
          }
        },
        rooms: {
          stepInfo: {
            title: 'Voer je vakantiegegevens in en ontvang gepersonaliseerde aanbiedingen via e-mail rechtstreeks van de accommodaties.'
          },
          errors: {
            required: {
              startDate: 'Het veld Aankomstdatum is verplicht',
              endDate: 'Het veld Vertrekdatum is verplicht',
              rooms: 'U moet ten minste één kamer/appartement invoeren'
            },
            min: {
              rooms: 'U moet ten minste één kamer/appartement invoeren'
            }
          }
        },
        services: {
          stepInfo: {
            title: 'Voer je gegevens in om gepersonaliseerde aanbiedingen rechtstreeks van de accommodaties te ontvangen!'
          },
          placeholders: {
            accotypes: 'Kies het type accommodatie',
            boardings: 'Kies de verzorging',
            amenities: 'Kies de faciliteiten',
            themes: 'Kies het vakantiethema',
            areas: 'Kies het gebied',
            searchAreas: "Zoek naar regio's en locaties..."
          },
          errors: {
            required: {
              accotypes: 'Je moet ten minste één type accommodatie selecteren',
              boardings: 'Je moet ten minste één type maaltijd selecteren',
              amenities: 'Je moet ten minste één faciliteit selecteren',
              themes: 'Je moet ten minste één type vakantie selecteren',
              areas: 'Je moet ten minste één bestemming selecteren'
            },
            maxValue: {
              count: 'Je kunt maximaal 80 accommodaties selecteren. Gebruik andere filters.'
            }
          }
        },
        accoRecap: {
          dialogs: {
            removeAccoConfirm: {
              title: 'Accommodatie verwijderen?',
              text: 'Weet je zeker dat je de accommodatie wilt verwijderen?',
              accetpLabel: 'Verwijderen',
              cancelLabel: 'Annuleren'
            }
          },
          stepInfo: {
            title: 'Hier zijn de accommodaties waarnaar je jouw aanvraag wilt sturen'
          }
        },
        nextLabelButton: 'Doorgaan',
        prevLabelButton: 'Terug',
        submitLabelButton: 'Aanvraag verzenden'
      },
      recap: {
        accomodations: {
          singular: 'accommodatie',
          plural: 'accommodaties'
        },
        adults: {
          singular: 'volwassene',
          plural: 'volwassenen'
        },
        children: {
          singular: 'kind',
          plural: 'kinderen'
        },
        rooms: {
          singular: 'kamer',
          plural: 'kamers'
        },
        accomodationTypes: 'Accommodatietype',
        locations: 'Regio/lokatie'
      },
      success: {
        direct: 'Niet-bindende directe navraag',
        general: 'Niet-bindende vraag',
        status: 'Aanvraag succesvol verzonden!',
        success: 'Uw aanvraag is succesvol verzonden.',
        similarAccos: 'Met één klik meer accommodatie aanvragen'
      },
      selectedRoom: {
        type: 'Type',
        size: 'Grootte',
        occupancy: 'Bezetting',
        person: 'Persoon',
        persons: 'Personen'
      },
      selectedPackage: {
        period: 'Periode',
        nights: 'Nachten'
      }
    },
    accoTypes: {
      acco: 'Accommodatie',
      accos: 'Accommodaties',
      hotel: 'Hotel',
      hotels: 'Hotels',
      fewo: 'Vakantieappartement / Residentie',
      fewos: 'Vakantieappartementen / Residenties'
    }
  }
}

const byString = function (s: string) {
  let o: any = translations
  s = s.replace(/\[(\w+)\]/g, '.$1')
  s = s.replace(/^\./, '')
  const a = s.split('.')
  for (let i = 0, n = a.length; i < n; ++i) {
    const k = a[i]
    if (k in o) {
      o = o[k]
    } else {
      return s
    }
  }
  return o ?? s
}

export default byString
